/** @ngInject */
export default function posSearchController($scope, $state, $http, $stateParams, userConfig, gridUtil, uiGridConstants, uiGridTreeBaseConstants, terms, $localStorage, $timeout, uiGridExporterConstants, uiGridGroupingConstants, $aside, $filter) {

    var exposureByUnderlying = [
        "underlyingTotal",
        "underlying",
        "branch",
        "adviser",
        "accountNumber"
    ];

    var exposureByAdviser = [
        "branch",
        "adviser",
        "accountNumber",
        "underlyingTotal",
        "underlying"
    ];

    var exposureValueField = "premium";

    $scope.showAggregatePositions = false;

    var localStorageDefault = {
        positionsSearch: {
            showAggregatePositions: false,
            showClosedPositions: false
        },
        positionsExposure: {
            field: "premium",
            group: "stock"
        }
    };

    $scope.$storage = $localStorage.$default(localStorageDefault);


    $scope.aggregatePositions = [];
    $scope.positions = [];

    $scope.assetDistributionChartType = $scope.$storage.positionsExposure.field;
    $scope.exposureChartGrouping = $scope.$storage.positionsExposure.group;

    $state.userConfig = userConfig;

    $scope.stockExposure = null;
    $scope.stockExposureOptions = {
        chart: {
            color: nv.utils.getColor(d3.scale.category20c().range()),
            type: "sunburstChart",
            height: 480,
            duration: 250,
            mode: "size",
            noData: "No Data Available",
            margin: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
            },
            tooltip: {
                valueFormatter: d3.format(",f")

                //contentGenerator : function() {
                //}
            }
        }
    };

    $scope.assetDistribution = [];

    $scope.assetDistributionOptions = {
        chart: {
            type: "pieChart",
            height: 550,
            donut: true,
            donutRatio: 0.2,
            padAngle: 0.005,
            x: function (d) {
                return d.key;
            },
            y: function (d) {
                return d.y;
            },
            showLabels: true,
            duration: 750,
            labelThreshold: 0.015,
            labelsOutside: false,
            cornerRadius: 5,

            labelSunbeamLayout: true,
            margin: {
                top: 10,
                right: 10,
                bottom: 30,
                left: 10
            }
        }
    };


    var defaultStorage = {};

    defaultStorage.positionsTour = {
        complete: false,
        skipped: false
    };
    defaultStorage.positionsTable = {
        version: 2
    };

    defaultStorage.positionsExposure = {
        group: "stock",
        field: "premium"
    };

    $scope.$storage = $localStorage.$default(defaultStorage);

    $scope.exposureChartGrouping = $scope.$storage.positionsExposure.group;

    $scope.updateFilterTerm = function (col) {
        if (col.dateTerm) {
            col.term = $filter("date")(col.dateTerm, "yyyy-MM-dd");
        } else {
            col.term = "";
        }
    };

    var data = [];

    function byMoneyness(a, b) {
        if (a.moneyness < b.moneyness) {
            return -1;
        } else if (a.moneyness > b.moneyness) {
            return 1;
        }
        return 0;
    }

    function byBadness(a, b) {
        if (a.badness < b.badness) {
            return -1;
        } else if (a.badness > b.badness) {
            return 1;
        }
        return 0;
    }

    $scope.updateExposureChartGrouping = function (groupingType) {
        $scope.exposureChartGrouping = groupingType;
        $scope.$storage.positionsExposure.group = groupingType;

        $scope.updateChart();
    };

    $scope.assetDistribution = [];
    $scope.updateAssetDistributionChartType = function (exposureType) {
        $scope.assetDistributionChartType = exposureType;
        $scope.$storage.positionsExposure.field = exposureType;

        if (exposureType === "premium") {
            exposureValueField = "premium";
        } else if (exposureType === "netDelta") {
            exposureValueField = "netDelta";
        } else if (exposureType === "dollarDelta") {
            exposureValueField = "dollarDelta";
        }

        $scope.updateChart();
    };

    // TODO this is now broken
    $scope.$on("elementClick.directive", function (angularEvent, event) {
        if (event.point.underlying) {
            $scope.$emit("position.search.table.preset", {

                filterColumn: "underlying",
                filterTerm: event.point.underlying,
                sortColumn: "netDelta",
                ascending: !event.point.long
            });
        }
    });


    $scope.$on("position.search.table.preset", function (event, preset) {
        $scope.gridApi.grid.getColumn(preset.filterColumn).filters[0].term = preset.filterTerm;

        var sortColumn = $scope.gridApi.grid.getColumn(preset.sortColumn);

        $scope.gridApi.grid.sortColumn(sortColumn, preset.ascending ? uiGridConstants.ASC : uiGridConstants.DESC, false);
        $scope.gridApi.grid.refresh(); // TODO this is needed for some reason
    });

    function createDefaultColumns() {
        return [
            {
                name: "org",
                field: "org.key",
                type: "string",
                cellTooltip: true,
                visible: false,
                groupingShowAggregationMenu: false,
                displayName: "equity_positions_search.ORGANISATION",
                width: "*",
                headerCellTemplate: "tf/uiGridHeaderCell",
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "branch",
                field: "branch.key",
                type: "string",
                groupingShowAggregationMenu: false,
                displayName: "Branch",
                width: "*",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.branch,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "branchName",
                field: "branch.name",
                type: "string",
                cellTooltip: true,
                visible: false,
                groupingShowAggregationMenu: false,
                displayName: "Branch Name", width: "*",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.branchName,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "adviser",
                field: "adviser.key",
                type: "string",
                cellTooltip: true,
                groupingShowAggregationMenu: false,
                displayName: "Adviser", width: "*",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.adviser,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "adviserName",
                field: "adviser.name",
                type: "string",
                visible: false,
                cellTooltip: true,
                groupingShowAggregationMenu: false,
                displayName: "Adviser Name", width: "*",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.adviserName,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "accountNumber",
                type: "string",
                displayName: "Account Number", width: "**",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.portfolioId})\">{{ row.entity['accountNumber'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.accNum,
                cellTooltip: true,
                groupingShowAggregationMenu: false,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },
            {
                name: "accountName",
                type: "string",
                displayName: "Account Name", width: "***",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.portfolioId})\">{{ row.entity['accountName'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.accName,
                cellTooltip: true,
                groupingShowAggregationMenu: false,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },

            {
                name: "ownerEmail",
                type: "string",
                visible: false,
                displayName: "Email", width: "***",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a href=\"mailTo:{{ row.entity['ownerEmail'] }}\">{{ row.entity['ownerEmail'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.ownerEmail,
                cellTooltip: true,
                groupingShowAggregationMenu: false,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },

            {
                name: "ownerPhone",
                type: "string",
                visible: false,
                displayName: "Phone", width: "***",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a href=\"tel:{{row.entity['ownerPhone']}}\">{{ row.entity['ownerPhone'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.ownerPhone,
                cellTooltip: true,
                groupingShowAggregationMenu: false,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                }
            },

            {
                name: "underlying",
                type: "string", cellTooltip: true,
                groupingShowAggregationMenu: false,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.security,
                displayName: "Underlying", width: "*"
            },

            {
                name: "expiry",
                type: "string",
                displayName: "Expiry", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.expiry,
                groupingShowAggregationMenu: false,
                width: "*",
                cellFilter: "date:\"dd-MMM-yy\"",
                filterHeaderTemplate: `<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                    <div class="input-group">
                                                        <input readonly
                                                               type="text"
                                                               class="ui-grid-filter-input"
                                                               uib-datepicker-popup="dd MMM yy"
                                                               datepicker-append-to-body="true"
                                                               ng-model="colFilter.dateTerm"
                                                               ng-change="grid.appScope.updateFilterTerm(colFilter)"
                                                               is-open="colFilter.isOpen"
                                                               ng-click="colFilter.isOpen = true"
                                                               show-button-bar="false"
                                                               ng-init="colFilter.mode = 'day'"
                                                               datepicker-mode="colFilter.mode"
                                                               datepicker-options="{showWeeks : false, formatMonth : 'MMM', yearRange : 5, maxMode : 'day', minMode : 'day'}"/>
                                                        <div class="ui-grid-filter-button ng-scope"
                                                             ng-click="colFilter.term = null;colFilter.dateTerm = null"
                                                             ng-if="!colFilter.disableCancelFilterButton">
                                                            <i class="ui-grid-icon-cancel"
                                                               ng-show="colFilter.term !== undefined && colFilter.term != null">
                                                                &nbsp;
                                                            </i>
                                                        </div>
                                                    </div>
                                                </div>`,
                filterable: true,
                filters: [{
                    flags: {
                        date: true
                    },
                    condition: uiGridConstants.filter.STARTS_WITH
                }]
            },
            {
                name: "strike",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.strike, cellTooltip: true,
                groupingShowAggregationMenu: false,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                displayName: "Strike",
                type: "number",
                width: "*",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.strike | strike:row.entity.code.indexOf('XJO') == 0}}</div>"
            },


            {
                name: "typeFilter",
                type: "string",
                groupingShowAggregationMenu: false,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.type, cellTooltip: true,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                },
                displayName: "Type",
                width: "110",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-if=\"row.entity.type\"><span style=\"width:3ch; display: inline-block\">{{row.entity.type | type}}</span><span ng-if=\"row.entity.style != 'FUTURE'\">&nbsp;&ndash;&nbsp;{{row.entity.style | style}}</span></span></div>"
            },
            {
                name: "code",
                type: "string", cellTooltip: true,
                groupingShowAggregationMenu: false,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.code,
                visible: false,
                displayName: "ASX Code", width: "*"
            },

            {
                name: "underlyingPrice",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.undPrice,
                displayName: "Und Price", width: "*",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber", cellTooltip: true,
                enableGrouping: false,
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-class=\"{itm : row.entity.itm, badPosition: row.entity.badPosition}\">{{row.entity.underlyingPrice | strike:row.entity.code.indexOf('XJO') == 0}}</div>"
            },

            {
                name: "quantity",
                type: "number",
                displayName: "Quantity", width: "*", cellTooltip: true,
                headerCellClass: "gridNumber", cellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.qty,
                enableGrouping: false,
                filter: {
                    condition: uiGridConstants.filter.LESS_THAN
                },
                footerCellClass: "gridNumber", footerCellFilter: "number:0",
                cellFilter: "number:0",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "bought",
                type: "number",
                visible: false, cellTooltip: true,
                displayName: "Bought", width: "*",
                headerCellClass: "gridNumber", cellClass: "gridNumber",
                enableGrouping: false,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                cellFilter: "number:0"
            },
            {
                name: "sold",
                type: "number",
                visible: false, cellTooltip: true,
                displayName: "Sold", width: "*",
                headerCellClass: "gridNumber", cellClass: "gridNumber",
                enableGrouping: false,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                cellFilter: "number:0"
            },
            {
                name: "cvf",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.CVF,
                type: "number",
                visible: false, cellTooltip: true,
                displayName: "CVF", width: "*",
                headerCellClass: "gridNumber", cellClass: "gridNumber",
                enableGrouping: false,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                cellFilter: "number:0"
            },
            {
                name: "tradedDate",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.openDate,
                type: "date",
                enableGrouping: false,
                visible: false, cellTooltip: true,
                displayName: "Opened", width: "*",
                cellFilter: "date : 'dd/MM/yyyy'"
            },
            {
                name: "tradedPrice",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.openPrice,
                type: "number", cellTooltip: true,
                groupingShowAggregationMenu: false,
                displayName: "Open", width: "*",
                headerCellClass: "gridNumber", cellClass: "gridNumber",
                cellFilter: "number : 4"
            },
            {
                name: "price",
                type: "number",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.theoPrice,
                enableGrouping: false, cellTooltip: true,
                displayName: "Price", width: "*",
                headerCellClass: "gridNumber", cellClass: "gridNumber",
                cellFilter: "number : 3"
            },
            {
                name: "intrinsicValue",
                headerCellTemplate: "tf/uiGridHeaderCell",
                cellTooltip: true,
                term: terms.intrinsic,
                visible: false,
                enableGrouping: false,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                displayName: "Intrinsic Value",
                type: "number",
                width: "*",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\">{{row.entity.intrinsicValue | strike:row.entity.code.indexOf('XJO') == 0}}</div>"
            },
            {
                name: "moneyness",
                enableGrouping: false,
                visible: false,
                filter: {
                    condition: uiGridConstants.filter.GREATER_THAN
                },
                displayName: "Moneyness",
                type: "number", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.moneyness,
                width: "*",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "percentage : 2"
            },
            {
                name: "netDelta",
                type: "number",
                displayName: "Net Delta",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.netDelta,
                width: "*", cellTooltip: true,
                enableGrouping: false,
                cellFilter: "number:0",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber", footerCellFilter: "number:0",
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "netGamma",
                type: "number",
                displayName: "Net Gamma",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.netGamma,
                width: "*", cellTooltip: true,
                enableGrouping: false,
                cellFilter: "number:4",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber", footerCellFilter: "number:4",
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "premium",
                type: "number",
                displayName: "Premium",
                width: "*",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.premMargin,
                enableGrouping: false,
                cellFilter: "ledger", cellTooltip: true,
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber", footerCellFilter: "ledger",
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span>{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "scanRisk",
                type: "number",
                visible: false,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.scanRisk,
                displayName: "Scan Risk",
                footerCellClass: "gridNumber", footerCellFilter: "ledger",
                width: "*", cellTooltip: true,
                enableGrouping: false,
                cellFilter: "ledger",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span>{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "pnl",
                type: "number",
                displayName: "P&L",
                width: "*",
                enableGrouping: false,
                footerCellClass: "gridNumber", footerCellFilter: "ledger",
                cellFilter: "ledger", cellTooltip: true,
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.pnl,
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "todayPnl",
                type: "number",
                displayName: "Today P&L",
                footerCellClass: "gridNumber", footerCellFilter: "ledger",
                width: "*",
                enableGrouping: false,
                cellFilter: "ledger", cellTooltip: true,
                headerCellClass: "gridNumber",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.pnl,
                cellClass: "gridNumber",
                cellTemplate: "<div class=\"ui-grid-cell-contents\"><span ng-class=\"{sell : COL_FIELD < 0}\">{{COL_FIELD CUSTOM_FILTERS}}</span></div>",
                aggregationType: uiGridConstants.aggregationTypes.sum, aggregationHideLabel: true,
                treeAggregationType: uiGridTreeBaseConstants.aggregation.SUM,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }

            }
        ];
    }

    function saveTablePreferences() {
        $timeout(function () {
            $scope.$storage.positionsTable = {
                version: 2,
                data: $scope.gridApi.saveState.save()
            };

        }, 100);
    }

    $scope.openTablePrefs = function () {
        var position = "right";
        var backdrop = true;

        $scope.asideState = {
            open: true,
            position: position
        };

        $aside.open({
            templateUrl: "/tradefloor/app/layout/tablePrefs/openPosPref.html",
            placement: position,
            size: "sm",
            backdrop: backdrop,
            controller: "TablePrefCtrl",
            resolve: {
                gridApi: function () {
                    return $scope.gridApi;
                }
            }

        });
    };

    // TODO hack to get visibiilty changes saving until there is a callback to trigger it
    $scope.$on("$destroy", function () {
        $state.current.data.startTour = undefined;
        saveTablePreferences();
    });


    $scope.resetColumnFilters = function () {

        var expiryColumn = $scope.gridApi.grid.getColumn("expiry");
        if (expiryColumn) {
            expiryColumn.colDef.filters[0].dateTerm = null;
        }

        $scope.gridApi.grid.resetColumnSorting();
        $scope.gridApi.grid.clearAllFilters();

        saveTablePreferences(); // Not sure why, but need to super save the value as there is no filter change being fired
    };

    $scope.resetColumnPreferences = function () {
        $scope.$storage.positionsTable = {
            version: 2
        };
        $scope.gridApi.grid.resetColumnSorting();
        $scope.gridApi.grid.clearAllFilters();
        $scope.gridOptions.columnDefs = createDefaultColumns();
    };

    $scope.gridOptions = {
        tableName: "Positions Search",
        flatEntityAccess: false,
        enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableFiltering: true,
        saveFilter: true,
        showColumnFooter: true,
        showTreeExpandNoChildren: true,
        saveSort: true,
        saveScroll: false,
        saveFocus: false,
        minRowsToShow: 20,
        enableGridMenu: false,
        enablePaging: false,
        excessRows: 15,
        treeRowHeaderAlwaysVisible: false,
        columnDefs: createDefaultColumns(),
        savePreferencesFn: saveTablePreferences,
        data: data,
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            gridUtil.disableAnimations(gridApi.grid.element);
            $scope.gridApi.colMovable.on.columnPositionChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.filterChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.sortChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.columnVisibilityChanged($scope, saveTablePreferences);
            $scope.gridApi.colResizable.on.columnSizeChanged($scope, saveTablePreferences);

            $timeout(function () {
                if ($scope.$storage.positionsTable) {
                    // Reset if the data isn't versioned
                    if ($scope.$storage.positionsTable.version === undefined) {
                        $scope.$storage.positionsTable.version = 2;
                        return;
                    }

                    if ($scope.$storage.positionsTable.data && $scope.$storage.positionsTable.version == 2) {
                        $scope.gridApi.saveState.restore($scope, $scope.$storage.positionsTable.data);
                    }
                }

            }, 0);
        },
        columnPresets: [
            {name: "Desktop", icon: "icon-desktop", minWidth: 1200, resetFn: createDefaultColumns}
        ]
    };

    $scope.exportCsv = function () {
        $scope.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
    };

    $scope.exportCsvVisible = function () {
        $scope.gridApi.exporter.csvExport(uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
    };


    $scope.refresh = function () {
        $http.get("/tradefloor/api/positions")
             .then(function (response) {
                 var advisers = response.data.advisers;
                 var adviserMap = {};
                 advisers.forEach(function (a) {
                     adviserMap[a.id] = a;
                 });

                 var branches = response.data.branches;
                 var branchMap = {};

                 branches.forEach(function (b) {
                     branchMap[b.id] = b;
                 });

                 var orgs = response.data.orgs || [];
                 var orgMap = {};

                 orgs.forEach(function (o) {
                     orgMap[o.id] = o;
                 });


                 var portfolios = response.data.portfolios;

                 $scope.aggregatePositions = [];
                 $scope.positions = [];

                 for (var i = 0; i < portfolios.length; i++) {
                     var portfolio = portfolios[i];

                     var aggregatePositionByCode = {};

                     for (var j = 0; j < portfolio.positions.length; j++) {
                         var position = portfolio.positions[j];

                         position.portfolioId = portfolio.portfolioId;
                         position.adviser = adviserMap[portfolio.adviserId];
                         position.branch = branchMap[portfolio.branchId];
                         position.org = orgMap[portfolio.orgId];
                         position.accountNumber = portfolio.accountNumber;
                         position.accountName = portfolio.accountName;
                         position.ownerEmail = portfolio.ownerEmail;
                         position.ownerPhone = portfolio.ownerPhone;

                         position.moneyness = 0;

                         var baseSide = 0;
                         if (position.type === "PUT") {
                             baseSide = -1;
                             position.itm = position.strike > position.underlyingPrice;
                             position.intrinsicValue = Math.max(0, (position.strike - position.underlyingPrice));
                             position.moneyness = position.intrinsicValue / position.strike;
                         } else if (position.type === "CALL") {
                             baseSide = 1;
                             position.itm = position.strike < position.underlyingPrice;
                             position.intrinsicValue = Math.max(0, (position.underlyingPrice - position.strike));
                             position.moneyness = position.intrinsicValue / position.strike;

                         } else {
                             position.itm = false;
                             position.intrinsicValue = 0;
                         }

                         var side = baseSide * position.quantity;

                         if (side < 0) {
                             position.badPosition = position.strike < position.underlyingPrice;
                             position.badness = (position.strike - position.underlyingPrice) / position.strike;
                         } else if (side > 0) {
                             position.badPosition = position.strike > position.underlyingPrice;
                             position.badness = (position.underlyingPrice - position.strike) / position.strike;
                         } else {
                             position.badPosition = false;
                             position.badness = 0;
                         }

                         position.typeFilter = position.type + "-" + position.style;
                         position.tradedDate = new Date(position.tradedDate);


                         position.dollarDelta = position.netDelta * position.underlyingPrice;

                         if (position.quantity >= 0) {
                             position.bought = position.quantity;
                             position.sold = undefined;
                         } else {
                             position.bought = undefined;
                             position.sold = -position.quantity;
                         }

                         $scope.positions.push(position);

                         var aggregatePosition = aggregatePositionByCode[position.code];
                         if (!aggregatePosition) {
                             aggregatePosition = {
                                 portfolioId: position.portfolioId,
                                 code: position.code,
                                 quantity: 0,
                                 cvf: position.cvf,
                                 price: position.price,
                                 underlying: position.underlying,
                                 underlyingPrice: position.underlyingPrice,
                                 expiry: position.expiry,
                                 strike: position.strike,
                                 intrinsicValue: position.intrinsicValue,
                                 moneyness: position.moneyness,
                                 badness: position.badness,
                                 itm: position.itm,
                                 badPosition: position.badPosition,
                                 type: position.type,
                                 typeFilter: position.typeFilter,
                                 style: position.style,
                                 accountNumber: position.accountNumber,
                                 accountName: position.accountName,
                                 ownerEmail: position.ownerEmail,
                                 ownerPhone: position.ownerPhone,
                                 adviser: position.adviser,
                                 branch: position.branch,
                                 org: position.org,
                                 netDelta: 0,
                                 netGamma: 0,
                                 premium: 0,
                                 pnl: 0,
                                 todayPnl: 0,
                                 tradedDate: position.tradedDate,
                                 scanRisk: 0,
                                 tradedPrice: 0,
                                 totalCost: 0,
                                 aggregated: false,
                                 buyPositions: [],
                                 sellPositions: []

                             };

                             aggregatePositionByCode[position.code] = aggregatePosition;

                             $scope.aggregatePositions.push(aggregatePosition);
                         } else {
                             aggregatePosition.aggregated = true;
                         }

                         var remainingQuantity = 0;
                         var matchQuantity = 0;

                         if (position.quantity > 0) {
                             remainingQuantity = position.quantity;

                             do {
                                 matchQuantity = 0;
                                 var sellPosition = aggregatePosition.sellPositions.shift();
                                 if (sellPosition) {
                                     matchQuantity = Math.min(remainingQuantity, sellPosition.quantity);
                                     if (matchQuantity) {
                                         remainingQuantity -= matchQuantity;
                                         sellPosition.quantity -= matchQuantity;
                                     }

                                     if (sellPosition.quantity) {
                                         aggregatePosition.sellPositions.unshift(sellPosition);
                                     }

                                 }

                             } while (matchQuantity);

                             if (remainingQuantity) {
                                 aggregatePosition.buyPositions.push({
                                     quantity: remainingQuantity,
                                     price: position.tradedPrice
                                 });
                             }

                         } else if (position.quantity < 0) {
                             remainingQuantity = -position.quantity;

                             do {
                                 matchQuantity = 0;
                                 var buyPosition = aggregatePosition.buyPositions.shift();
                                 if (buyPosition) {
                                     matchQuantity = Math.min(remainingQuantity, buyPosition.quantity);
                                     if (matchQuantity) {
                                         remainingQuantity -= matchQuantity;
                                         buyPosition.quantity -= matchQuantity;

                                     }
                                     if (buyPosition.quantity) {
                                         aggregatePosition.buyPositions.unshift(buyPosition);
                                     }
                                 }
                             } while (matchQuantity);

                             if (remainingQuantity) {
                                 aggregatePosition.sellPositions.push({
                                     quantity: remainingQuantity,
                                     price: position.tradedPrice
                                 });
                             }
                         }

                         var totalCost = 0;
                         aggregatePosition.buyPositions.forEach(function (pos) {
                             totalCost += pos.quantity * pos.price;
                         });

                         aggregatePosition.sellPositions.forEach(function (pos) {
                             totalCost -= pos.quantity * pos.price;
                         });

                         aggregatePosition.totalCost = totalCost;
                         aggregatePosition.quantity += position.quantity;
                         if (aggregatePosition.quantity) {
                             aggregatePosition.tradedPrice = aggregatePosition.totalCost / aggregatePosition.quantity;
                         } else {
                             aggregatePosition.tradedPrice = 0;
                         }

                         aggregatePosition.pnl = (aggregatePosition.quantity * aggregatePosition.price * aggregatePosition.cvf) - (aggregatePosition.quantity * aggregatePosition.tradedPrice * aggregatePosition.cvf);

                         aggregatePosition.netDelta += position.netDelta; // This will have rounding errors
                         aggregatePosition.netGamma += position.netGamma; // This will have rounding errors
                         aggregatePosition.scanRisk += position.scanRisk;
                         aggregatePosition.premium += position.premium;
                         aggregatePosition.todayPnl += position.todayPnl;

                         if (aggregatePosition.quantity >= 0) {
                             aggregatePosition.bought = aggregatePosition.quantity;
                             aggregatePosition.sold = undefined;
                         } else {
                             aggregatePosition.bought = undefined;
                             aggregatePosition.sold = -aggregatePosition.quantity;
                         }

                         if (position.tradedDate < aggregatePosition.tradedDate) {
                             aggregatePosition.tradedDate = position.tradedDate;
                         }

                         var aggregateBaseSide = 0;
                         if (aggregatePosition.type === "PUT") {
                             aggregateBaseSide = -1;
                         } else if (position.type === "CALL") {
                             aggregateBaseSide = 1;
                         }

                         var aggregateSide = aggregateBaseSide * position.quantity;

                         if (aggregateSide < 0) {
                             aggregatePosition.badPosition = aggregatePosition.strike < aggregatePosition.underlyingPrice;
                             aggregatePosition.badness = (aggregatePosition.strike - aggregatePosition.underlyingPrice) / aggregatePosition.strike;
                         } else if (aggregateSide > 0) {
                             aggregatePosition.badPosition = aggregatePosition.strike > aggregatePosition.underlyingPrice;
                             aggregatePosition.badness = (aggregatePosition.underlyingPrice - aggregatePosition.strike) / aggregatePosition.strike;
                         } else {
                             aggregatePosition.badPosition = false;
                             aggregatePosition.badness = 0;
                         }

                     }
                 }

                 $scope.updateAssetDistributionChartType($scope.assetDistributionChartType);

                 $scope.positions.sort(byBadness);
                 $scope.aggregatePositions.sort(byBadness);

                 $scope.updateChart();
                 $scope.updateGridData();

             });

        $scope.lastUpdated = new Date();
    };

    $scope.toggleShowAggregatedPositions = function () {
        $scope.$storage.positionsSearch.showAggregatePositions = !$scope.$storage.positionsSearch.showAggregatePositions;
        $scope.updateGridData();

    };

    $scope.toggleShowClosedPositions = function () {
        $scope.$storage.positionsSearch.showClosedPositions = !$scope.$storage.positionsSearch.showClosedPositions;
        $scope.updateGridData();

    };

    $scope.updateGridData = function () {
        if ($scope.$storage.positionsSearch.showAggregatePositions) {
            $scope.gridOptions.data = $scope.aggregatePositions;
        } else {
            $scope.gridOptions.data = $scope.positions;
        }

        if (!$scope.$storage.positionsSearch.showClosedPositions) {
            $scope.gridOptions.data = $scope.gridOptions.data.filter((row) => row.quantity !== 0);
        }
    };

    $scope.updateChart = function () {
        var total = {
            name: "Total",
            size: 0,
            children: [],
            childrenMap: {},
            group: "total",
            color: "grey"
        };

        var exposureGrouping = exposureByUnderlying;

        if ($scope.exposureChartGrouping == "adviser") {
            exposureGrouping = exposureByAdviser;
        } else if ($scope.exposureChartGrouping == "stock") {
            exposureGrouping = exposureByUnderlying;
        }


        $scope.positions.forEach(function (p) {
            var size = p[exposureValueField];

            if (exposureValueField == "premium") {
                size = -size;
            }

            var currentGroup = total;

            total.size += Math.abs(size);
            total.value += size;

            exposureGrouping.forEach(function (g, i) {
                var groupName;
                var groupValue = Math.abs(size);

                switch (g) {
                    case "branch":
                        groupName = p.branch ? p.branch.name : "";
                        break;
                    case "adviser":
                        groupName = p.adviser ? p.adviser.name : "";
                        break;
                    case "accountNumber":
                        groupName = p.accountNumber;
                        break;
                    case "underlyingTotal":
                        groupName = p.underlying;
                        break;
                    case "underlying":
                        groupName = p.underlying + (size < 0 ? " Short" : " Long");
                        break;
                }

                var group = currentGroup.childrenMap[groupName];
                if (!group) {
                    group = {
                        name: groupName,
                        size: 0,
                        value: 0,
                        children: [],
                        childrenMap: {},
                        group: g
                        //color : 'red'
                    };

                    currentGroup.children.push(group);
                    currentGroup.childrenMap[groupName] = group;
                }

                group.size += groupValue;
                group.value += size;
                currentGroup = group;
            });


        });

        function sortChildren(total) {
            total.children.forEach(sortChildren);

            total.children.sort(bySize);
        }

        function bySize(a, b) {
            if (a.size < b.size) {
                return 1;
            }

            if (a.size > b.size) {
                return -1;
            }

            return 0;
        }


        sortChildren(total);

        function compressLevel(level) {
            level.children.forEach(compressLevel);

            if (level.children.length > 11) {
                var newChildren = level.children.slice(0, 10);
                var others = level.children.slice(10);

                var other = {
                    name: others.length + " Others",
                    size: 0,
                    value: 0,
                    children: [],
                    childrenMap: {},
                    group: level.group,
                    color: "grey"
                };

                others.forEach(function (o) {
                    other.size += o.size;
                    other.value += o.value;
                });

                newChildren.push(other);
                level.children = newChildren;

            }
        }

        compressLevel(total);

        $scope.stockExposure = [total];
        if ($scope.chartApi) {
            $scope.chartApi.updateWithData($scope.stockExposure);
        }
    };

    $scope.refresh();
}